/* eslint-disable no-underscore-dangle */
const { CONSENTMANAGER } = require('../../../../../config/analytics');
const {
  getCMPData,
  onCMPReady,
  addCMPEventListener,
  existsUserChoice,
} = require('./consentManager');

/**
 * Run a function when the visitor choices a cookies policy option
 * @param {ConsentManagerEventHandler} handler Callback function
 */
function onVisitorChoicesConsentSetting(handler) {
  onCMPReady(() => {
    if (existsUserChoice()) {
      handler.call(this, [CONSENTMANAGER.events.settings, getCMPData(), null]);
    } else {
      addCMPEventListener(CONSENTMANAGER.events.consent, handler);
    }
  });
}

module.exports = {
  onVisitorChoicesConsentSetting,
};
